import React from 'react';

import styles from './AssetAllocation.css';

import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import PieChart from '../../components/PieChart/PieChart';
import Legend from '../../components/Legend/Legend';
import TablePreRender from '../../components/Table/Table.prerender';

import { MF_ASSET_ALLOCATION, ETF_ASSET_ALLOCATION } from './queries';
import { assetAllocationUtil } from './util';
import { displayCurrencyShort } from '../../utils/Format/Format';

const AssetAllocationCard = ({ etf, ticker }) => (
    <Card>
        <GqlQueryWrapper
            query={etf ? ETF_ASSET_ALLOCATION : MF_ASSET_ALLOCATION}
            dataFunc={assetAllocationUtil}
            variables={{ ticker }}
            placeholder={() => <TablePreRender />}
        >
            {({
                data: {
                    data,
                    legendData,
                    asOfDate,
                    totalNetAssets,
                    someAssetAllocationsNegative
                }
            }) => (
                <div className="container">
                    <h2>{displayCurrencyShort(totalNetAssets)}</h2>
                    <h3>Total Net Assets as of {asOfDate}</h3>

                    {someAssetAllocationsNegative || (
                        <div className="pie-container">
                            <div className="pie">
                                <PieChart
                                    title={
                                        <React.Fragment>
                                            Asset<br />Allocation
                                        </React.Fragment>
                                    }
                                    width={219}
                                    height={219}
                                    margin={0}
                                    ringWidth={8}
                                    cornerRadius={0}
                                    colors={data.map((d) => d.color)}
                                    data={data}
                                />
                            </div>
                            <div className="legend">
                                <Legend data={legendData} vertical />
                            </div>
                        </div>
                    )}
                    {someAssetAllocationsNegative && (
                        <div className="legend-container">
                            <Legend data={legendData} vertical percentOnly />
                        </div>
                    )}
                </div>
            )}
        </GqlQueryWrapper>

        <style jsx>{styles}</style>
    </Card>
);

export default AssetAllocationCard;
